import React from 'react';

import { unwrapGlobalCmsRecordFromPageQuery } from './cms-provider/global-cms-provider';
import { GlobalCmsContent } from './global-content';

type GlobalContentProviderProps = {
  children: React.ReactNode;
  globalCmsPageData: unknown;
};

export const GlobalContentProvider = ({
  children,
  globalCmsPageData,
}: GlobalContentProviderProps) => (
  <GlobalCmsContent.Provider value={unwrapGlobalCmsRecordFromPageQuery(globalCmsPageData)}>
    {children}
  </GlobalCmsContent.Provider>
);

export default GlobalContentProvider;
